export const AnalysisDaysOptions = [
  { value: 1, key: 1, text: '1 - Daily Analysis Only' },
  { value: 2, key: 2, text: '2 - Daily Analysis Only' },
  { value: 3, key: 3, text: '3' },
  { value: 4, key: 4, text: '4' },
  { value: 5, key: 5, text: '5' },
  { value: 6, key: 6, text: '6' },
  { value: 7, key: 7, text: '7' },
];



// WEBPACK FOOTER //
// ./src/common/Constants/analysisDays.js